import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { HoldsService } from 'src/app/_services/holds.services';
import { RetentionService } from 'src/app/_services/retention.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component'
import { environment } from '@environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-apply-hold',
  templateUrl: './apply-hold.component.html',
  styleUrls: ['./apply-hold.component.scss']
})
export class ApplyHoldComponent implements OnInit {
  @Input() documentID: any;
  @Input() holdGroupNames: any;
  @Input() hold: boolean;
  allHolds: any = [];
  unappliedHolds: any = [];
  searchCtrl: string = "";
  holdIDs: number[];
  selectedHeader: number;
  retentionInfo: any;
  message: string = "";
  archiveMessage: string = "";
  isNull: boolean = false;
  isArchiveNull: boolean = false;
  holdApplied: boolean = false;
  archive: boolean;
  holdListCols = ["holdName", "action"];
  selectedRow: Array<JSON> = []
  holdsList: MatTableDataSource<any>;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.holdsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.holdsList.paginator = this.paginator;
    }
  }

  constructor(
    public dialog: MatDialog,
    private holdsService: HoldsService,
    private retentionService: RetentionService,
    private config: AppConfig
  ) { }

  ngOnInit() {
    this.archive = this.config.getConfig("archive")
    this.holdsService.getHoldGroups().subscribe(holds => {
      this.allHolds = holds;
      this.populateUnappliedHolds(holds);
    })
    this.retentionService.getRetentionInfo(this.documentID).subscribe(data => {
      this.retentionInfo = data
      if (this.retentionInfo.hasOwnProperty('message')) {
        if (this.retentionInfo.message.includes("No retention applied to document")) {
          this.isNull = true;
          this.isArchiveNull = true;
          this.message = "No Retention applied to this document."
          this.archiveMessage = "No Archival Policy applied to this document."
        }

      } else if((this.config.getConfig("archive")) && this.retentionInfo[0].archival_date == null) {
        this.isArchiveNull = true;
        this.archiveMessage = "No Archival Policy applied to this document."
      }
    })
    this.setMatTableData(this.holdGroupNames)
  }

  populateUnappliedHolds(holds) {
    this.unappliedHolds = holds.slice(0);
    this.holdGroupNames.forEach(holdGroupName => {
      this.unappliedHolds.forEach(holdGroup => {
        if (holdGroup.name == holdGroupName) {
          this.unappliedHolds.splice(this.unappliedHolds.indexOf(holdGroup), 1);
        }
      });
    });
  }

  applyHold() {
    const request = {
      "holdgroupid": this.holdIDs,
      "document_id": this.documentID
    }
    this.holdsService.applyHold(request).subscribe(data => {
      this.allHolds.forEach(element => {
        this.holdIDs.forEach(holdId => {
          if (element.id == holdId) {
            this.holdGroupNames.push(element.name)
          }
        })
      });
      this.setMatTableData(this.holdGroupNames)
      this.holdApplied = true
      this.hold = true;
    })
  }

  removeHold(holdGroup) {
    //this.holdIDs = []
    var holdIDs = []
    this.allHolds.forEach(element => {
      if (element.name == holdGroup) {
        holdIDs.push(element.id)
      }
    });
    var data = {
      type: "Remove Hold",
      payload: {
        "document_id": this.documentID,
        "holds": holdIDs
      }
    }
    this.confirmDialog(data, holdGroup)
  }

  removeAllHolds() {
    var holdIDs = []
    this.holdGroupNames.forEach(holdGroupName => {
      this.allHolds.forEach(holdGroup => {
        if (holdGroup.name == holdGroupName) {
          holdIDs.push(holdGroup.id)
        }
      });
    });
    var data = {
      type: "Remove Hold",
      payload: {
        "document_id": this.documentID,
        "holds": holdIDs
      }
    }
    //this.confirmDialog(data)
  }

  confirmDialog(data, holdGroup) {
    let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
      { width: '500px', data: data });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.holdApplied = false;
        this.hold = false;
        this.holdGroupNames.splice(this.holdGroupNames.indexOf(holdGroup), 1);
        this.setMatTableData(this.holdGroupNames)
        if (this.holdGroupNames.length > 0) {
          this.hold = true
        }
        this.populateUnappliedHolds(this.allHolds);
        this.holdIDs = null;
      }
    });
  }

  back() {
    this.holdIDs = null
    this.holdApplied = false
    this.populateUnappliedHolds(this.allHolds);
  }

  setMatTableData(holdGroupData) {
    this.holdsList = new MatTableDataSource(holdGroupData)
    this.holdsList.sort = this.sort;
    this.holdsList.paginator = this.paginator;
  }

}
